// IE 2026 10 14 / ODOO-5800 (Igor 14.10, M03 1coh_001: после правки ячейки через мгновение чипс «Corrections» пропадал, а Save гасла, хотя значение и подсветка
// оставались): фоновый ответ бэка (опрос каскада autoRecalc_check → cascade_state_refresh → updateDoc с updates бейджа, финиш прогона и т.п.) рассылает
// WidgetAttrs.content_Changed без isVue — грид принимал его за НОВЫЕ ДАННЫЕ и сбрасывал историю undo/redo, changesStack, modified и сим-сессию,
// хотя массив строк записи не заменялся. Свежесть данных — по ссылке на массив строк: тот же массив — состояние правки грида остаётся.
// Выключатель fe.ux.editKeepOnSameRows (дефолт ВКЛ): false — прежнее поведение (любой ответ без isVue сбрасывает правки).
export const EDIT_KEEP_SAME_ROWS_FLAG = 'fe.ux.editKeepOnSameRows'

export function editKeep_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(EDIT_KEEP_SAME_ROWS_FLAG, true) !== false : true } catch (e) { return true }
}

// строки грида те же, что были загружены (массив не заменён ответом бэка): current — текущий массив привязки (сырой, без прокси),
// loaded — массив, из которого грид собран в последний load_data. Не массив (форма записи, AttrTabGrid) — считаем новыми данными, как раньше
export function editKeep_sameRows(current, loaded, flagOn = true) {
    if (!flagOn) return false
    return Array.isArray(current) && Array.isArray(loaded) && current === loaded
}

// что из состояния правки переживает перестройку по тем же строкам (load_data): снимок до и возврат после — undo/redo возвращаются
// В ТЕ ЖЕ массивы (ссылки на них держат чипс и панель), остальное — присваиванием
export function editKeep_snapshot(vm) {
    return { undo: [...(vm.undoStack || [])], redo: [...(vm.redoStack || [])], changesStack: vm.changesStack, backendStack: vm.backendStack, deletedItems: vm.deletedItems, modified: !!vm.modified }
}

export function editKeep_restore(vm, snap) {
    if (!snap) return
    if (vm.undoStack) { vm.undoStack.length = 0; for (const a of snap.undo) vm.undoStack.push(a) }
    if (vm.redoStack) { vm.redoStack.length = 0; for (const a of snap.redo) vm.redoStack.push(a) }
    vm.changesStack = snap.changesStack || {}
    vm.backendStack = snap.backendStack || {}
    vm.deletedItems = snap.deletedItems || []
    vm.modified = snap.modified
}

// IE 2026 10 14 / ODOO-5800 (Igor: остаток замирания при клике по флажку согласования в 1coh_001 под правилами оформления): правка ячейки
// ЗАМОРОЖЕННОЙ колонки — wijmo _updateEditorCell делает refresh(false) и в startEditing, и в finishEditing (два полных прохода formatItem,
// на бою ≈ 1–2 с каждый), а точечный проход editKeep был заблокирован у гридов с cf_rules. Выключатель fe.ux.boolEditKeepRefresh (дефолт ВКЛ):
// с правилами оформления / заливкой от метрик проход точечный по области строк (ниже), взвод и на refresh startEditing (editKeep_armStart),
// строка правки и предки после set_value — прямым updateCell отрисованных ячеек (editRefresh_cells), а не refreshRange. false — как до правки
export const BOOL_EDIT_KEEP_FLAG = 'fe.ux.boolEditKeepRefresh'

export function boolEditKeep_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(BOOL_EDIT_KEEP_FLAG, true) !== false : true } catch (e) { return true }
}

// строки, чьё отображение может зависеть от правки строки irow: она сама, предки (итоги по колонке) и потомки (наследование, пометки
// строки-алерта) — как раньше; плюс, если задан lacksField (правила оформления читают правленую колонку, а значение у строки без поля
// берётся у ближайшего предка с полем — cf_inheritOn): строки поддерева ВЕРХНЕГО предка, у которых поля нет и чей ближайший предок С ПОЛЕМ —
// изменившаяся строка (правленая или её предок). Строка без поля под неизменившимся промежуточным предком с полем читает его — не трогаем
// (замер dev02 1coh_001: «все строки без поля» давало область почти со весь грид, пропуск 14 ячеек из 790). rows — строки грида
// ({level, dataItem}); level == null — плоский грид (только строка)
export function editKeep_scopeRows(rows, irow, lacksField = null) {
    const set = new Set([irow])
    const l0 = rows[irow]?.level
    if (l0 == null) return set
    let lvl = l0, top = irow
    for (let i = irow - 1; i >= 0 && lvl > 0; i--) { if (rows[i].level < lvl) { set.add(i); lvl = rows[i].level; top = i } }
    for (let i = irow + 1; i < rows.length && rows[i].level > l0; i++) set.add(i)
    if (typeof lacksField === 'function') {
        const changed = new Set(set)   // правленая строка и предки (потомки ниже — свои значения не меняли, но они и так в области)
        const lt = rows[top].level
        const stack = []   // [уровень, «ближайший предок с полем — изменившаяся строка»]
        for (let i = top; i < rows.length && (i === top || rows[i].level > lt); i++) {
            const lv = rows[i].level
            while (stack.length && stack[stack.length - 1][0] >= lv) stack.pop()
            const parentSrc = stack.length ? stack[stack.length - 1][1] : false
            const lacks = i !== irow && !!lacksField(rows[i].dataItem)
            const src = lacks ? parentSrc : changed.has(i)
            if (lacks && src && !set.has(i)) set.add(i)
            stack.push([lv, src])
        }
    }
    return set
}

// строки объединённого диапазона ячейки (merge «назад» / mergeColumns: диапазон ячейки до и после правки может отличаться) — в область
export function editKeep_addRange(set, rng) {
    if (!set || !rng || typeof rng.row !== 'number' || typeof rng.row2 !== 'number') return set
    const a = Math.min(rng.row, rng.row2), b = Math.max(rng.row, rng.row2)
    if (b - a > 10000) return set
    for (let r = a; r <= b; r++) set.add(r)
    return set
}

// колонки отрисованных ячеек строки: замороженные (0 … fz-1) и видимый диапазон viewRange; vr — {col, col2}
export function editRefresh_cols(vr, fz) {
    const cols = []
    const f = Math.max(0, fz | 0)
    for (let c = 0; c < f; c++) cols.push(c)
    if (vr && typeof vr.col === 'number' && typeof vr.col2 === 'number') for (let c = Math.max(vr.col, f); c <= vr.col2; c++) cols.push(c)
    return cols
}

// IE 2026 10 14 / ODOO-5800 (app7 #84472, бой ev33 на 20 тыс. строк: Ctrl+Z после флажка — итоги через 4,8 с; CDP-профиль dev02 pfperf3: changeStack_ сбрасывал кэш
// частичных итогов целиком, deferUpdate → endUpdate → invalidate (полный проход wijmo), затем flexRefresh (apply_CHIPS + второй полный проход; formatItem 1 864 ячеек
// с холодным cf_cache 4,0 с), а регистрация строки на python-пересчёт шла мимо no_process_dataItem колонки — третий полный проход из pyRecalc_batch 1,1 с).
// Теперь undo / redo группы, состоящей только из правок ЯЧЕЕК, идёт тем же точечным путём, что и сама правка (set_value): кэш итогов сбрасывается только у
// предков (approvalPartial_afterEdit внутри set_value), без deferUpdate и flexRefresh — перерисовываются прямым updateCell строки правки, их предки и потомки
// (область editKeep_scope, как при вводе). Выключатель fe.ux.undoKeepRefresh (дефолт ВКЛ; false — прежний путь с полными перерисовками)
export const UNDO_KEEP_FLAG = 'fe.ux.undoKeepRefresh'

export function undoKeep_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(UNDO_KEEP_FLAG, true) !== false : true } catch (e) { return true }
}

// верхняя группа стека (одно действие пользователя = один actionStack) состоит только из правок ячеек: method val / aggEdit / color / backgroundColor / comment /
// cells с col_binding и строкой по ссылке ($item). Структурные записи (rows / props), записи без строки, пустой стек или группа больше cap — null (полный путь)
export function undoKeep_group(stack, cap = 200) {
    if (!Array.isArray(stack) || !stack.length) return null
    const top = stack[stack.length - 1]
    if (!top || top.actionStack == null) return null
    const out = []
    for (let i = stack.length - 1; i >= 0; i--) {
        const a = stack[i]
        if (!a || a.actionStack !== top.actionStack) break
        if (a.col_binding == null || a.method === 'rows' || a.method === 'props' || !a.$item) return null
        out.push(a)
        if (out.length > cap) return null
    }
    return out.length ? out : null
}
